import React from 'react';

import {
  Tooltip,
  TooltipAlign,
  TooltipPlacement,
} from 'src/components/tooltip-new';
import {
  OutlinedButton,
  ButtonText,
  ButtonIcon,
} from '@prisjakt/ui/button/variants';

import * as S from './styles';

type IconButtonProps = {
  isActive: boolean;
  icon: React.ReactNode;
  ariaLabel: string;
  tooltip: string;
  tooltipAlign?: TooltipAlign;
  tooltipPlacement?: TooltipPlacement;
  onClick?: (e: React.MouseEvent) => void;
  layout?: 'icon' | 'button';
};

const BaseButton = ({
  isActive,
  icon,
  ariaLabel,
  tooltip,
  tooltipAlign = TooltipAlign.RIGHT,
  tooltipPlacement = TooltipPlacement.TOP,
  onClick,
  layout,
}: IconButtonProps) => {
  if (layout === 'button') {
    return (
      <OutlinedButton onClick={onClick}>
        <ButtonIcon>{icon}</ButtonIcon>
        <ButtonText>{ariaLabel}</ButtonText>
      </OutlinedButton>
    );
  }

  return (
    <Tooltip
      title={tooltip}
      align={tooltipAlign}
      placement={tooltipPlacement}
      width={180}
    >
      <S.IconButton
        role="button"
        active={isActive}
        aria-label={ariaLabel}
        onClick={onClick}
      >
        {icon}
      </S.IconButton>
    </Tooltip>
  );
};
export default BaseButton;
